import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DeleteAssessmentService } from '../../shared/services/delete-assessment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareDataService } from '../../shared/services/shared.service';
import { ResponseModal } from '../../shared/models/response.model';
import { ButtonType } from '../../shared/components/button/button-type';
import { ButtonPurpose } from '../../shared/components/button/button-purpose';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { queueLiveAnnouncement } from '../../utils/shared-utils';

@Component({
    selector: 'delete-assessment',
    templateUrl: './delete-assessment.component.html',
    styleUrls: ['./delete-assessment.component.scss'],
    standalone: false
})

export class DeleteAssessmentComponent implements OnInit {
  collectionId: any;
  private error;
  alertMessageData: ResponseModal = { 'Message' : '', 'collectionId': 0 , 'isSuccess' : false};
  public buttonType = ButtonType;
  public _buttonPurpose = ButtonPurpose;

  constructor(private deleteAssessmentService: DeleteAssessmentService, private shareService: ShareDataService, private router: Router, private route: ActivatedRoute, private titleService: Title, private liveAnnouncer: LiveAnnouncer) { }

  ngOnInit() {
    const pageTitle = 'Delete Confirmation | Test Builder';
    this.titleService.setTitle(pageTitle);
    // In SPAs, screen readers don't auto-detect title changes. LiveAnnouncer explicitly announces the page title for accessibility.
    queueLiveAnnouncement(this.liveAnnouncer, pageTitle, 'assertive');
	  this.collectionId = this.route.snapshot.paramMap.get('id');

	  this.deleteAssessmentService.deleteAssessment(this.collectionId).subscribe(data => {
        this.alertMessageData = data;
        this.shareService.sendMessageData(this.alertMessageData);
      }, error => {
        this.error = error;
      });
  }

	closeModal() {
		this.alertMessageData.Message = '';
		this.router.navigate(['/list']);
	}
}
